module.exports = __webpack_public_path__ + "static/header-left-e3d1f49913b318d3fa00ea8e4fef5f13.png";